import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const NavDropdown = ({ label, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div 
            className="relative" 
            onMouseEnter={() => setIsOpen(true)} 
            onMouseLeave={() => setIsOpen(false)}
        >
            <button
                className="page-link text-sm md:text-base font-medium px-3 py-2 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 flex items-center"
            >
                <span>{label}</span>
                <ChevronDown size={16} className={`ml-1 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>
            
            {isOpen && (
                <div className="absolute top-full left-0 w-56 bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 z-20">
                    <div className="py-1 flex flex-col">
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NavDropdown;